import RetryImage from '../../UI/RetryImage';
import { DETAIL_TOKENS } from '../../../styles/UISystem';

/**
 * PhotosSection — shared PHOTOS section for the connection detail pages.
 * Renders a 2-column grid of shared image messages; renders nothing when there
 * are none.
 *
 * Props:
 *   messages - chat messages (filtered to contentType === 'image' here)
 *   onOpen - called with a photo's content URL when tapped (opens the lightbox)
 *   headerless - bare grid with no width wrapper, for a caller that supplies its
 *     own. Photos carry no container or label on either page (frames).
 */
/**
 * The photos gate, shared with surfaces that wrap the grid in their own card
 * (Anon detail) — one predicate, no drift (same pattern as hasAboutContent).
 */
export const hasPhotoMessages = (messages) =>
  (messages || []).some((m) => m.contentType === 'image');

const PhotosSection = ({ messages, onOpen, headerless = false }) => {
  const photos = (messages || []).filter((m) => m.contentType === 'image');
  if (photos.length === 0) return null;

  const grid = (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '8px',
      }}
    >
      {photos.map((photo) => (
        <RetryImage
          key={photo.id}
          src={photo.content}
          alt="Shared photo"
          onClick={() => onOpen(photo.content)}
          style={{
            width: '100%',
            aspectRatio: '1',
            objectFit: 'cover',
            borderRadius: '12px',
            cursor: 'pointer',
          }}
        />
      ))}
    </div>
  );

  if (headerless) return grid;

  return <div style={{ width: '100%', maxWidth: DETAIL_TOKENS.SECTION_MAX_WIDTH }}>{grid}</div>;
};

export default PhotosSection;
